"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Domains = void 0;
exports.Domains = [
    'designview.io',
    '99designs.pt',
    '99designs.com.br',
    '99designs.nl',
    '99designs.be',
    '99designs.jp',
    '99designs.it',
    'it.99designs.ch',
    '99designs.fr',
    'fr.99designs.ch',
    'fr.99designs.be',
    'es.99designs.com',
    '99designs.com.mx',
    '99designs.es',
    '99designs.com.co',
    '99designs.cl',
    '99designs.com',
    '99designs.com.sg',
    'en.99designs.pt',
    '99designs.no',
    'en.99designs.nl',
    'en.99designs.com.mx',
    'en.99designs.jp',
    'en.99designs.it',
    '99designs.ie',
    '99designs.hk',
    '99designs.co.uk',
    'en.99designs.fr',
    'en.99designs.es',
    '99designs.dk',
    'en.99designs.de',
    'en.99designs.com.co',
    'en.99designs.cl',
    'en.99designs.ch',
    '99designs.ca',
    'en.99designs.com.br',
    'en.99designs.be',
    '99designs.com.au',
    'en.99designs.at',
    '99designs.de',
    '99designs.ch',
    '99designs.at',
    '99d.me',
];
